// ------------------------------------
// EXIBIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'caracteristicas-var';
    const ref2 = 'caracteristicas';
    const refEvtPrefix = 'lp-evt-caracteristicas-';

    // Elementos
    const $section = $('#caracteristicas');

    // Oculta/Exibe a seção
    function changeSecShow() {
      const value = confTheme[ref2]['caracteristicas-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
  }
})();

// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'caracteristicas-var';
    const ref2 = 'caracteristicas';
    const refEvtPrefix = 'lp-evt-caracteristicas-';

    // Elementos
    const $section = $('#caracteristicas');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref2]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref2]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref2]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['caracteristicas-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--caracteristicas-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// TEXTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'caracteristicas-var';
    const ref2 = 'caracteristicas';
    const refEvtPrefix = 'lp-evt-caracteristicas-';

    // Elementos
    const $section = $('#caracteristicas');
    const $secTitle = $('.caracteristicas-titulo');
    const $secText = $('.caracteristicas-texto');

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['titulo'];
      $secTitle.html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'titulo', changeTitle);

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['caracteristicas-tit-color'];
      $section[0].style.setProperty('--caracteristicas-tit-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['texto'];
      $secText.html(fmtTxt(value));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['caracteristicas-txt-color'];
      $section[0].style.setProperty('--caracteristicas-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera a cor do fundo os itens da lista
    function changeListItemBgColor() {
      const color = confTheme[ref]['list-item-bg-color'];
      $section[0].style.setProperty('--list-item-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'list-item-bg-color', changeListItemBgColor);

    // Altera a cor do texto os itens da lista
    function changeListItemTxtColor() {
      const color = confTheme[ref]['list-item-txt-color'];
      $section[0].style.setProperty('--list-item-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'list-item-txt-color', changeListItemTxtColor);

    // Altera a cor de destaque do texto
    function changeTxtAltColor() {
      const color = confTheme[ref]['txt-alt-color'];
      $section[0].style.setProperty('--txt-alt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-alt-color', changeTxtAltColor);

    // Altera a cor de fundo do texto
    function changeTxtBgColor() {
      const color = confTheme[ref]['txt-bg-color'];
      $section[0].style.setProperty('--txt-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-bg-color', changeTxtBgColor);
  }
})();

// ------------------------------------
// BOTÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'caracteristicas-var';
    const ref2 = 'caracteristicas';
    const refEvtPrefix = 'lp-evt-caracteristicas-';

    // Elementos
    const $secButton = $('.caracteristicas-botao');

    // Oculta/Exibe o botão
    function changeBtnShow() {
      const value = confTheme[ref2]['btn-show'];
      value == '1' ? $secButton.removeClass('d-none') : $secButton.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-show', changeBtnShow);

    // Altera a classe do botão
    function changeBtnClass() {
      const value = confTheme[ref2]['btn-class'];
      const styleClass = confTheme['general'][value + '-style'];
      const AnimationClass = confTheme['general'][value + '-animation'];
      $secButton
        .find('.btn')
        .removeClass(btnClassesRem)
        .addClass(value + ' ' + styleClass + ' ' + AnimationClass);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

    // Altera o texto do botão
    function changeBtnText() {
      const value = confTheme[ref2]['btn-text'];
      $secButton.find('.btn').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-text', changeBtnText);

    // Oculta/Exibe o selo
    function changeSealShow() {
      const value = confTheme[ref2]['seal-show'];
      value == '1'
        ? $secButton.find('.btn-selos').removeClass('d-none')
        : $secButton.find('.btn-selos').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'seal-show', changeSealShow);
  }
})();

// ------------------------------------
// DIVISOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'caracteristicas-var';
    const ref2 = 'caracteristicas';
    const refEvtPrefix = 'lp-evt-caracteristicas-';

    // Altera o divisor
    function changeDivider() {
      const value = confTheme[ref2]['divisor'];
      $('.caracteristicas .section-divider').addClass('d-none');
      if (value) {
        $('.caracteristicas .section-divider.' + value).removeClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

    // Altera a cor do divisor
    function changeDividerColor() {
      const color = confTheme[ref]['divisor-color'];
      $('#caracteristicas')[0].style.setProperty('--divisor-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
  }
})();

// ------------------------------------
// LISTA
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'caracteristicas-var';
    const ref2 = 'caracteristicas';
    const refEvtPrefix = 'lp-evt-caracteristicas-';

    // Elementos
    const $list = $('#caracteristicas_lista');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['lista'];
      if ($list.length > 0) {
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          const item = `
          <li class="md-text"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"/></svg><span>${fmtTxt(
            lista[i].titulo,
            true,
          )}</span></li>`;
          $list.append(item);
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista', changeList);
  }
})();
